var SENTRY_RELEASE;SENTRY_RELEASE={name: "Visioni", version: "2026.10.4"};